import React, { useEffect } from "react";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../modules/login";
import Hero from "../components/ui-library/Hero/Hero";
import Card from "../components/ui-library/HomeCard/HomeCard";
import styled, { withTheme } from "styled-components";
import { useTranslation } from "react-i18next";

const StyledContent = styled.div`
  background-color: ${(props) => props?.theme?.bg};
  color: ${(props) => props?.theme?.fg};
  width: 100%;
  min-height: 100vh;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease;
  &.active {
    padding-left: 160px;
  }
  @media (max-width: 1024px) {
    padding: 0rem;
  }
`;

const Landing = () => {
  const { t } = useTranslation();

  return (
    <StyledContent id="content" className="container-fluid" dir="ltr">
      <>
        <Hero
          header={t("appText.landing.header.welcome")}
          bodyText={t("appText.landing.body.welcome")}
        />
        <Card
          header={t("appText.landing.header.lcfaod")}
          bodyText={t("appText.landing.body.lcfaod")}
        />
        <Card
          header={t("appText.landing.header.ultragenyx")}
          bodyText={t("appText.landing.body.ultragenyx")}
          buttonText={t("appText.landing.learnMore")}
          btnAction={() => window.open("https://www.ultragenyx.com/", "_blank")}
          primaryButton={true}
        />
      </>
    </StyledContent>
  );
};

export default connect(mapStateToPropsLogin, null)(withTheme(Landing));
